// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames/bind';
import Arrow from '../../../../../elements/Arrow/Arrow';
import Slider from 'react-slick';
import { Default, Mobile } from '../../../../../utils/responsive';
import Modal from '../../../../../elements/Modal/Modal';
import RadioButton from '../../../../../elements/RadioButton/RadioButton';

import style from './RelatedProducts.scss';
import icons from '../../../../../assets/styles/icons.scss';
import buttonStyle from '../../../../../assets/styles/button.scss';

import withoutBoxImg from '../../../../../assets/img/new-order/without-box.png';
import withBoxImg from '../../../../../assets/img/new-order/with-box.png';

import type { Element } from 'react';
import type { LocalValuesState } from '../../../../local-values/duck';
import type { Product } from '../../../../featured-products/duck';

type Props = {
  +localValues: LocalValuesState;
  +products: Product[];
  +handleAddRelatedProduct: (productIndex: number, withBoxOption?: number) => void;
};

type State = {
  leftArrow: boolean;
  rightArrow: boolean;
  openModal: boolean;
  withBox: {
    value: number;
    errors?: string[];
  };
  productIndex?: number;
};

const withBoxOptions = [
  {
    intl: 'newOrder.product.form.box.no',
    img: withoutBoxImg,
    alt: 'withoutBox',
  },
  {
    intl: 'newOrder.product.form.box.yes',
    img: withBoxImg,
    alt: 'withBox',
  },
];

export default class RelatedProducts extends Component<Props, State> {
  state = {
    leftArrow: true,
    rightArrow: false,
    openModal: false,
    withBox: {
      value: 0,
    },
    productIndex: undefined,
  };

  handleArrowStyle = (current: number, lastIndex: number) => {
    const leftArrow = current === 0;
    const rightArrow = current === lastIndex;
    this.setState({ leftArrow, rightArrow });
  };

  buildProducts = (): Element<'article'>[] => {
    const { products } = this.props;
    return products.map((product: Product, index: number) => {
      return (
        <article className={style.product}
                 key={index}>
          <img src={product.image} alt="Qempo" draggable="false"/>
          <section className={style.bottomHalf}>
            <p className={style.name}>{product.name}</p>
            <section className={style.bottom}>
              <p>$ {product.price}</p>
              <FormattedMessage id="relatedProducts.add">{
                txt => <p className={style.add}
                          onClick={() => this.handleClickProduct(index)}>
                  <i className={icons.symbolShoppingCartAdd}/>
                  {txt}</p>
              }</FormattedMessage>
            </section>
          </section>
        </article>
      )
    });
  };

  handleClickProduct = (index: number) => {
    const { localValues, products, handleAddRelatedProduct } = this.props;
    const itemCategoryId = products[index].categoryId;
    if (localValues.categoriesMap && localValues.categoriesMap[itemCategoryId].originalPackagingSelectable) {
      this.handleOpenModal(index);
    } else {
      handleAddRelatedProduct(index);
    }
  };

  handleOpenModal = (index: number) => {
    this.setState({ openModal: true, productIndex: index });
  };

  handleCloseModal = () => {
    this.setState({ openModal: false, productIndex: undefined, withBox: { value: 0 } });
  };

  handleChangeBoxOption = (withBoxValue: number) => {
    this.setState({
      withBox: { value: withBoxValue },
    });
  };

  render() {
    const { handleAddRelatedProduct } = this.props;
    const { rightArrow, leftArrow, openModal, withBox, productIndex } = this.state;
    const products = this.buildProducts();
    const slidesToShow = 1;
    const mobileSettings = {
      infinite: false,
      slidesToScroll: 1,
      speed: 500,
      arrows: true,
      slidesToShow: slidesToShow,
      draggable: true,
      dots: true,
      dotsClass: classNames('slick-dots', style.dots),
      nextArrow: <Arrow icon={icons.iconChevronRightMedium}
                        positionClass={style.arrowRight}
                        visible={rightArrow}/>,
      prevArrow: <Arrow icon={icons.iconChevronLeftMedium}
                        positionClass={style.arrowLeft}
                        visible={leftArrow}/>,
      afterChange: (current) => this.handleArrowStyle(current, products.length - slidesToShow),
    };
    return (
      <Fragment>
        <section className={style.mainWrap}>
          <FormattedMessage id="relatedProducts.title">{
            txt => <h3 className={style.title}>{txt}</h3>
          }</FormattedMessage>
          <section className={style.productsWrap}>
            <Mobile>
              <Slider {...mobileSettings}>
                {products}
              </Slider>
            </Mobile>
            <Default>
              {products}
            </Default>
          </section>
        </section>
        <Modal open={openModal}
               handleClose={this.handleCloseModal}
               big>
          <section className={style.boxOptionsWrap}>
            <FormattedMessage id="relatedProducts.modal.question">{
              txt => <p className={style.question}>{txt}</p>
            }</FormattedMessage>
            <section className={style.withBox}>
              {withBoxOptions.map((option: { [key: string]: string }, index: number) =>
                (<article key={index}
                          className={classNames(style.packaging, { [style.selected]: withBox.value === index })}
                          onClick={() => this.handleChangeBoxOption(index)}>
                  <RadioButton name="withBox"
                               value={index}
                               selected={withBox.value}
                               handleChange={_ => {
                               }}/>
                  <img src={option.img} alt={option.alt}/>
                  <FormattedMessage id={option.intl}>{
                    txt => <p>{txt}</p>
                  }</FormattedMessage>
                </article>)
              )}
            </section>
            <FormattedMessage id="relatedProducts.modal.add">{
              txt => <button type="button"
                             className={classNames(buttonStyle.btn, buttonStyle.lightBlue)}
                             onClick={() => {
                               this.handleCloseModal();
                               typeof productIndex !== 'undefined' && handleAddRelatedProduct(productIndex, withBox.value);
                             }}
              >{txt}</button>
            }</FormattedMessage>
          </section>
        </Modal>
      </Fragment>
    );
  }
}

RelatedProducts.propTypes = {
  localValues: PropTypes.object.isRequired,
  products: PropTypes.array.isRequired,
  handleAddRelatedProduct: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/new-order/QuoteStep/components/RelatedProducts/RelatedProducts.jsx